import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'oligonKentimaDoubleYpsiliLeft';
const args = {};

export class OligonKentimaDoubleYpsiliLeft extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
